<template>
  <PageTemplate :page="data" />
</template>

<script setup lang="ts">
  const { setDefaultDataLayer } = useSeo();
  // Ovaj page će uhvatiti sve moguće url-ove
  const { page, meta, head, template, isWebsiteInited, get } = usePage()
  const { middleware: _localMiddleware } = useAuth('local')
  const { middleware: _aminessMiddleware } = useAuth('aminess')
  const envVariables = useRuntimeConfig();
  const route = useRoute();
  const config = useRuntimeConfig();
  const { lang } = useLanguage();
  const { user: authData } = useAuth('aminess');

  const middlewares = {
    local: _localMiddleware,
    aminess: _aminessMiddleware,
  }

  // Podaci za page koje ćemo prosljediti kao prop
  // Namjerno se ne koristi page iz usePage već prop data zato jer će se prilikom
  // svakog novog dohvaćanja podataka promjeniti podaci unutar usePage prije nego što
  // završi tranzicija s pagea na page, što može dovesti do problema

  // Dohvaćanje podataka za page s backenda ili preuzimanje podataka dohvaćenih na serveru
  const data = (isWebsiteInited.value ? await get() : page.value) as Page

  // Template komponenta
  const PageTemplate = defineAsyncComponent(async () => {
    try {
      const _template = await import(`../templates/${template.value}.vue`)
      const auth = _template.default?.auth;
      if(auth) await middlewares[auth]()
      return _template
    } catch (e) {
      console.dir(e)
      // Bacanje greške ako backend nije vratio template
      throw createError({
        statusCode: 404,
        statusMessage: 'Page not found',
        fatal: true
      })
    }
  })

  let hreflangList = [];
  const languageSwitcher = page.value?.language_switcher;
  if (languageSwitcher && Object.keys(languageSwitcher).length) {
    hreflangList = Object.keys(languageSwitcher).map((key) => {
      return {
        rel: 'alternate',
        hreflang: key,
        href: `${ envVariables.public.domain }${ page.value.language_switcher[key] }`
      }
    })

    if (languageSwitcher['en']) hreflangList.push({ rel: 'alternate', hreflang: 'x-default', href: `${ envVariables.public.domain }${ languageSwitcher['en'] }` })
  }
  const combinedHead = computed(() => {
    let link = hreflangList;
    if (head.value.link) {
      link = [...hreflangList, ...head.value.link]
    }

    return {
      ...head.value,
      link,
    }
  });

  let breadcrumbsList = [];
  if (page.value?.breadcrumbs?.length) {
    breadcrumbsList = page.value.breadcrumbs.map((item, index) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "name": item.title,
        "item": item.url
      }
    })
  }
  
  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbsList
  }))

  onMounted(() => {
    window.dataLayer = window.dataLayer || [];
    if(window.dataLayer.length && window.dataLayer[0].event_data) {
      window.dataLayer.push({
        'event': 'page_view',
        'page_title': page?.value?.title || undefined,
        'page_location': window?.location?.href || undefined,
        'page_referrer': window?.history?.state?.back ? `${window?.location?.origin}${window?.history?.state?.back}` : undefined,
        'event_data': {
          'environment': 'development',
          'page_type': page?.value?.seo_page_type || 'other',
          'language': lang?.value || ''
        },
        'user_data': {
          'login_method' : authData?.value && Object.keys(authData.value).length ? 'email' : 'guest',
          'user_id': authData?.value?.loyalty?.card_number || undefined,
        }
      });
    }
    else {
      if(template.value !== 'Checkout') {
        setDefaultDataLayer();
      }
    }
  });

  useHead(combinedHead.value)
  useSeoMeta(meta.value as any)
</script>
